import { Button } from "@mui/material";
import { Link } from "react-router-dom";


const Screens = () => {
    return(
        <div className="m-5 grid grid-cols-1 gap-4 p-4 max-w-[600px]">
            <Button variant="contained" component={Link} to={'/screen/welcome'}>Welcome Screen</Button>
            <Button variant="contained" component={Link} to={'/screen/space-map'}>Space Map Screen</Button>
            <Button variant="contained" component={Link} to={'/screen/thank-you'}>Thank You Screen</Button>            
            <Button variant="contained" component={Link} to={'/screen/end'}>End Screen</Button>            
        </div>
    )
}

export default Screens;